/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Goal_Mobility_PlanInputs */

const en_portal_goal_mobility_plan = /** @type {(inputs: Portal_Goal_Mobility_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Short 20-minute sessions every day`)
};

const pl_portal_goal_mobility_plan = /** @type {(inputs: Portal_Goal_Mobility_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Krótkie sesje po 20 minut codziennie`)
};

/**
* | output |
* | --- |
* | "Short 20-minute sessions every day" |
*
* @param {Portal_Goal_Mobility_PlanInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_goal_mobility_plan = /** @type {((inputs?: Portal_Goal_Mobility_PlanInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Goal_Mobility_PlanInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_goal_mobility_plan(inputs)
	return en_portal_goal_mobility_plan(inputs)
});